/**
 * Gemeinsame Formatierungs-Helfer fuer Kurse, Prozente und Datum (de-DE)
 * sowie kleine Browser-Helfer.
 */

/** Loest den Download einer Textdatei im Browser aus (z.B. Schluesseldatei). */
export function ladeTextHerunter(dateiname, inhalt) {
  const url = URL.createObjectURL(new Blob([inhalt], { type: 'text/plain' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = dateiname;
  link.click();
  URL.revokeObjectURL(url);
}

/** Formatiert einen Kurs als Währung. Null/undefined -> „–". */
export function formatKurs(value, currency) {
  if (value == null) return '–';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
  }).format(value);
}

/** Prozent-Änderung mit Vorzeichen. Null/undefined -> „–". */
export function formatProz(value) {
  if (value == null) return '–';
  const v = Number(value);
  return `${v >= 0 ? '+' : ''}${v.toFixed(2)} %`;
}

/** Absolute Kursveränderung als Währung MIT Vorzeichen (+/-). Null/undefined -> „–". */
export function formatVeraenderung(value, currency) {
  if (value == null) return '–';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
    signDisplay: 'always',
  }).format(value);
}

/** Reine Zahl mit fester Nachkommastelle (de-DE). Null/undefined -> „–". */
export function formatZahl(value, digits = 2) {
  if (value == null) return '–';
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

/**
 * Große Geldbeträge kompakt (z.B. „1,2 Mrd. €"). Für Jahres-Kennzahlen wie
 * Umsatz/Gewinn. Null/undefined -> „–".
 */
export function formatKompakt(value, currency) {
  if (value == null) return '–';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currency || 'EUR',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value);
}

/** ISO-Datum (YYYY-MM-DD) -> deutsches Datum (DD.MM.YYYY). */
export function formatDatum(value) {
  if (!value) return '–';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('de-DE');
}

/**
 * Erzeugt einen Vergleichsfunktion für Array.sort anhand eines Wert-Getters.
 * Leere Werte (null/undefined/"") landen immer am Ende – unabhängig von der
 * Sortierrichtung. Strings werden de-locale verglichen, Zahlen numerisch.
 *
 * @param {(row: any) => any} getValue Liefert den Sortierwert einer Zeile.
 * @param {'asc' | 'desc'} dir         Sortierrichtung.
 */
export function makeComparator(getValue, dir) {
  return (a, b) => {
    const va = getValue(a);
    const vb = getValue(b);
    const aLeer = va == null || va === '';
    const bLeer = vb == null || vb === '';
    if (aLeer || bLeer) {
      if (aLeer && bLeer) return 0;
      return aLeer ? 1 : -1;
    }
    let cmp;
    if (typeof va === 'string' || typeof vb === 'string') {
      cmp = String(va).localeCompare(String(vb), 'de', { sensitivity: 'base' });
    } else {
      cmp = Number(va) - Number(vb);
    }
    return dir === 'asc' ? cmp : -cmp;
  };
}
